import { FC, useCallback, useMemo } from 'react'
import cn from 'classnames'
import styles from 'components/features/future/FutureAllLayersPane/FutureAllLayersPane.styl'
import { FloatingPaneLayout } from 'components/features/pfm/FloatingPaneLayout/FloatingPaneLayout'
import { FloatingPaneHeader } from 'components/features/pfm/FloatingPaneHeader/FloatingPaneHeader'
import { FloatingPaneFooter } from 'components/features/pfm/FloatingPaneFooter/FloatingPaneFooter'
import { useStoreDispatch, useStoreSelector } from 'helpers/reactReduxHelpers'
import { modifyFloatingPaneActionCreator, openSubscriptionPageActionCreator } from 'actions/floatingPanesActions'
import { ButtonsGroup } from 'components/features/future/FutureAllLayersPane/ButtonsGroup'
import { FutureLayerSlug } from 'components/features/future/types'
import { layersSelector } from 'components/features/future/selectors'
import { isMemberPremiumSelector } from 'selectors/globalSelectors'

type FutureAllLayersPaneProps = {
  onCancel: () => void
}

export const FutureAllLayersPane: FC<FutureAllLayersPaneProps> = ({ onCancel }) => {

  const headerChild = useMemo(() => (
    <FloatingPaneHeader
      title='Add a Goal or Event'
      iconSlug='add_goal'
      progressBarPercent={ 33 }
      theme='goal'
      centered
    />
  ), [])

  const footerChild = useMemo(() => (
    <FloatingPaneFooter onCancel={ onCancel } />
  ), [onCancel])

  const dispatch = useStoreDispatch()
  const layersCount = useStoreSelector((state) => layersSelector(state).length)
  const isMemberPremium = useStoreSelector(isMemberPremiumSelector)

  const handleSelectLayer = useCallback<(slug: FutureLayerSlug) => void>((slug) => {
    if (!isMemberPremium && layersCount >= 2) {
      dispatch(openSubscriptionPageActionCreator())
      return
    }

    dispatch(modifyFloatingPaneActionCreator('future', {
      mode: 'layer-details',
      slug,
    }))
  }, [dispatch, isMemberPremium, layersCount])

  return (
    <FloatingPaneLayout
      type='future'
      header={ headerChild }
      footer={ footerChild }
      onClose={ onCancel }
      withStaticHeader
    >
      <section className={ styles.futureAllLayersPane }>
        <h4 className={ cn(styles.groupTitle, styles.goalTheme) }>Goals</h4>
        <ButtonsGroup type='goal' onClick={ handleSelectLayer } />
        <h4 className={ styles.groupTitle }>Events</h4>
        <ButtonsGroup type='event' onClick={ handleSelectLayer } />
      </section>
    </FloatingPaneLayout>
  )
}
